import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ActivityIndicator } from 'react-native';
import { theme } from '../../shared/theme/theme';
import { useAuth } from '../../infrastructure/auth/AuthContext';
import { BankIdService } from '../../infrastructure/services/BankIdService';

export const HomeeVerificationScreen: React.FC<{ onVerified: () => void }> = ({ onVerified }) => {
  const { session } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!session) return;
    setLoading(true);
    const result = await BankIdService.startVerification(session.user.id, session.user.email ?? '');
    setLoading(false);
    if (result.success) onVerified();
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Ověření identity</Text>
      <Text style={styles.body}>
        Abyste mohli přijímat zakázky jako HoMee, musíte se ztotožnit přes BankID.
        U nás neexistuje anonymita — je to podmínka pro vaši bezpečnost i bezpečnost klientů.
      </Text>
      <TouchableOpacity style={styles.button} onPress={handleVerify} disabled={loading}>
        {loading
          ? <ActivityIndicator color="#FFF" />
          : <Text style={styles.buttonText}>OVĚŘIT PŘES BANKID</Text>}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: theme.colors.background, padding: 30, justifyContent: 'center', alignItems: 'center' },
  title: { fontSize: 26, fontWeight: '900', color: theme.colors.text.main, marginBottom: 16, textAlign: 'center' },
  body: { fontSize: 14, color: theme.colors.text.muted, textAlign: 'center', marginBottom: 40, lineHeight: 20 },
  button: { height: 56, width: '100%', maxWidth: 380, backgroundColor: theme.colors.accent, borderRadius: 12, justifyContent: 'center', alignItems: 'center' },
  buttonText: { color: '#FFF', fontWeight: '900', letterSpacing: 1 },
});
